module.exports = __webpack_public_path__ + "img/29.ff09d327.svg";